module.exports = __webpack_public_path__ + "static/media/jest.3e3633fb.svg";